// extracted by mini-css-extract-plugin
module.exports = {"banner":"az_Sfb","overrideMainBody":"az_Tfb","defaultBodyText":"az_Ufb"};